import { reduxFormWorksheet } from '@flowio/redux-form-overlay';

import FormNames from '../constants/FormNames';
import EditShippingAddressForm from '../components/EditShippingAddressForm';

export default reduxFormWorksheet({
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  form: FormNames.EDIT_SHIPPING_ADDRESS_FORM,
})(EditShippingAddressForm);
